module.exports = "<nv-react-component component=\"AnalyticsInstitutionDashboard\"></nv-react-component>";